import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { Page, Banner, BlockStack, Link, FooterHelp } from '@shopify/polaris';

import { install, findOrCreate } from '../redux/actions/stores';
import { getSettings } from '../redux/actions/settings';

import LoadingPlaceholder from './partials/LoadingPlaceholder';

// Gates the admin app on two things before rendering children:
//   1. POST /install - exchanges the session token for an offline token
//      and ensures the worker's Store record + webhooks exist
//   2. An active Shopify managed-pricing subscription (returned on the
//      /store response) - hard gate, sends merchants to the app's
//      Shopify-hosted pricing plans page
//
// A failed subscription lookup fails open (children render) rather than
// wrongly locking out paying merchants when Shopify can't be reached.
const AdminGate = ({ children, stores, installStore, loadStore, loadSettings }) => {
  useEffect(() => {
    installStore().then(() => {
      loadStore();
      loadSettings();
    });
  }, [installStore, loadStore, loadSettings]);

  const pricingUrl = stores.store
    ? `https://admin.shopify.com/store/${stores.store.split('.myshopify.com')[0]}/charges/${import.meta.env.VITE_APP_HANDLE}/pricing_plans`
    : null;

  if (stores.status === 'success') {
    if (import.meta.env.VITE_PRICING_REDIRECT === '1' && stores.activeSubscriptions.length === 0 && pricingUrl) {
      return (
        <Page title="Pack Perfect">
          <BlockStack gap="500">
            <Banner
              title="Activate Pack Perfect"
              action={{ content: 'Choose a plan', target: '_top', url: pricingUrl }}
              tone="info"
            >
              <p>Subscribe to a Pack Perfect plan to start using the app.</p>
            </Banner>
            <FooterHelp>
              By using Pack Perfect, you acknowledge that you have read and agree to A Thousand Apps Inc.'s <Link url="https://athousandapps.com/terms-of-service/" external>Terms of Service</Link> and <Link url="https://athousandapps.com/privacy-policy/" external>Privacy Notice</Link>, both of which govern your use of this service.
            </FooterHelp>
          </BlockStack>
        </Page>
      );
    }

    return children;
  }

  return (
    <Page title="Pack Perfect">
      <BlockStack gap="500">
        <LoadingPlaceholder />
        <LoadingPlaceholder />
        <LoadingPlaceholder />
      </BlockStack>
    </Page>
  );
};

const mapStateToProps = state => ({
  stores: state.stores,
});

const mapDispatchToProps = (dispatch) => ({
  installStore: () => dispatch(install()),
  loadStore: () => dispatch(findOrCreate()),
  loadSettings: () => dispatch(getSettings()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminGate);
